import React from "react";
import { Modal } from "react-bootstrap";
import EditExpertise from "./editExpretiseFull";

export default function EditExpertiseModal({
  show,
  onHide,
  expertiseId,
}) {
  if (!expertiseId) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>🧠 Édition de l’expertise</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
        <EditExpertise expertiseId={expertiseId} />
      </Modal.Body>
    </Modal>
  );
}
